import PageBase from "../../components/PageBase";

const BI = () => {
  return (
    <PageBase title="BI" removeMargins>
      <div style={{ width: '100%', height: 'calc(100vh - 64px)' }}>
        <iframe
          title="BI Dashboard"
          src="https://bi-dev-flow.connact.cloud"
          style={{ width: '100%', height: '100%', border: 'none' }}
          allow="fullscreen"
        />
      </div>
    </PageBase>
  );
};

export default BI;
